/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Studio_TitleInputs */

const cs_templates_studio_title = /** @type {(inputs: Templates_Studio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šablony`)
};

const en_templates_studio_title = /** @type {(inputs: Templates_Studio_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Templates`)
};

/**
* | output |
* | --- |
* | "Templates" |
*
* @param {Templates_Studio_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_studio_title = /** @type {((inputs?: Templates_Studio_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Studio_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_studio_title(inputs)
	return cs_templates_studio_title(inputs)
});